const blobPath = (cx, cy, r, wobble, phase) => {
  let d = "";
  for (let a = 0; a <= 360; a += 5) {
    const rad = (a * Math.PI) / 180;
    const rr =
      r *
      (1 + wobble * Math.sin(3 * rad + phase) + wobble * 0.6 * Math.cos(5 * rad + 1.3));
    const x = cx + rr * Math.cos(rad);
    const y = cy + rr * Math.sin(rad) * 0.62;
    d += (a === 0 ? "M" : "L") + x.toFixed(1) + " " + y.toFixed(1);
  }
  return d + "Z";
};

const CONTOURS = Array.from({ length: 15 }, (_, i) => ({
  d: blobPath(1130, 820, 80 + i * 52, 0.17, i * 0.35),
  opacity: 0.05 + i * 0.011,
  dashed: i % 3 === 1,
}));

const CROSSHAIRS = [
  [220, 180],
  [520, 340],
  [860, 160],
  [340, 640],
  [1180, 420],
  [700, 760],
  [1340, 640],
];

export default function TopoCanvas({ className = "", strokeBase = "0, 240, 255" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 1440 900"
      preserveAspectRatio="xMidYMid slice"
      fill="none"
      aria-hidden="true"
    >
      {CONTOURS.map((c, i) => (
        <path
          key={i}
          d={c.d}
          stroke={`rgba(${strokeBase}, ${c.opacity.toFixed(3)})`}
          strokeWidth={i % 4 === 0 ? 1.4 : 1}
          className={c.dashed ? "contour-dash" : ""}
        />
      ))}
      {CROSSHAIRS.map(([x, y], i) => (
        <g key={i} stroke={`rgba(${strokeBase}, 0.28)`} strokeWidth="1">
          <line x1={x - 9} y1={y} x2={x + 9} y2={y} />
          <line x1={x} y1={y - 9} x2={x} y2={y + 9} />
          <circle cx={x} cy={y} r="4" />
        </g>
      ))}
      <text
        x="60"
        y="810"
        fontFamily="JetBrains Mono, monospace"
        fontSize="11"
        fill={`rgba(${strokeBase}, 0.35)`}
        letterSpacing="2"
      >
        UTM 24M 552140m E
      </text>
      <text
        x="60"
        y="830"
        fontFamily="JetBrains Mono, monospace"
        fontSize="11"
        fill={`rgba(${strokeBase}, 0.35)`}
        letterSpacing="2"
      >
        9588420m S — SIRGAS 2000
      </text>
    </svg>
  );
}
